import React, { useEffect } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
import {
  FormInput,
  FormTemplate,
  FormTextArea,
} from "../../../Components/Forms/InputTemplate";
import { FormProvider, useForm } from "react-hook-form";
import {
  ActionButtons,
  SupportButtons,
} from "../../../../global/components/Buttons/buttons";
import { useLocation, useNavigate, useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import {
  getSingleWeekendAllowance,
  UpdateMyWeekendAllowance,
} from "../../../../../utils/redux/HR/HRSlice";
import { toast } from "react-toastify";

function UpdateWeekendAllowance() {
  const dataInfo = useLocation()?.state?.editData;
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading, single_weekend_allowance } = useSelector(
    (state) => state?.hr
  );

  console.log({ dataInfo });

  const formMethods = useForm({
    mode: "all",
    defaultValues: {
      NumberOfDays: "",
      Assignment: "",
    },
  });

  const {
    handleSubmit,
    reset,
    formState: { isValid },
  } = formMethods;

  const submit = (data) => {
    const dataValues = {
      NumberOfDays: data?.NumberOfDays,
      Assignment: data?.Assignment,
      RequisitionId: Number(id),
    };

    console.log("Submitted Data:", dataValues);

    // const fileData = new FormData();
    // Object.keys(dataValues).forEach((key) => {
    //   fileData.append(`${key}`, dataValues[key]);
    // });

    dispatch(UpdateMyWeekendAllowance(dataValues)).then((res) => {
      console.log("Response", res);
      if (res?.payload?.successful === true) {
        navigate("/dashboard/employee/weekend-allowance");
        reset();
      } else if (res?.payload?.successful === false) {
        toast.error(res?.payload?.statusMessage);
      }
    });
  };

  useEffect(() => {
    dispatch(getSingleWeekendAllowance(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (single_weekend_allowance) {
      const { numberOfDays, assignment } =
        single_weekend_allowance?.responseObject || {};
      reset({
        NumberOfDays: numberOfDays || "",
        Assignment: assignment || "",
      });
    }
  }, [single_weekend_allowance, reset]);

  return (
    <PageLayout title="Update Weekend Allowance" hasBack={true}>
      <FormProvider {...formMethods}>
        <FormTemplate handleSubmit={handleSubmit(submit)}>
          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>
              Weekend Allowance Information
            </h4>
            <div className={DashboardStyle.inputs_group}>
              <div>
                <FormInput
                  title="Number Of Days"
                  camelCase="NumberOfDays"
                  disabled={false}
                  isOptional={false}
                  type="number"
                />
              </div>
              <div>
                <FormTextArea
                  title="Assignment"
                  camelCase="Assignment"
                  placeholder="Enter request assignment"
                  type="textbox"
                  isOptional={false}
                />
              </div>
            </div>
          </section>

          <div className={DashboardStyle.button_cage}>
            <SupportButtons width="auto" onClick={() => navigate("../")}>
              No, Cancel
            </SupportButtons>
            <ActionButtons
              disabled={!isValid}
              isLoading={isLoading}
              className={DashboardStyle?.button_cage_weight}
            >
              {isLoading ? "Submitting" : "Update"}
            </ActionButtons>
          </div>
        </FormTemplate>
      </FormProvider>
    </PageLayout>
  );
}

export default UpdateWeekendAllowance;
